'use client';

import { evaluate } from '@mdx-js/mdx';
import { MDXProvider, useMDXComponents } from '@mdx-js/react';
import type { MDXComponents } from 'mdx/types';
import { ReactNode, useEffect, useState } from 'react';
import * as runtime from 'react/jsx-runtime';

interface MarkdownRendererProps {
  content: string;
  components?: MDXComponents;
  disableParentContext?: boolean;
}

export function MarkdownRenderer({
  content,
  components,
  disableParentContext,
}: MarkdownRendererProps) {
  const [element, setElement] = useState<ReactNode>();
  useEffect(() => {
    let isMounted = true;
    const instantiate = async () => {
      const { default: MDXContent } = await evaluate(content, {
        ...runtime,
        useMDXComponents,
      });
      isMounted && setElement(<MDXContent components={components} />);
    };
    instantiate();
    return () => {
      isMounted = false;
    };
  }, [content]);
  return (
    <MDXProvider disableParentContext={disableParentContext}>
      {element}
    </MDXProvider>
  );
}
